/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { format, parseISO } from 'date-fns'
import { serviceDeactivateUserLicenses } from '@/services/user-licenses'
import { useAuth0 } from '@auth0/auth0-react'
import DefaultTable from '@/components/tables/DefaultTable'
import CardWithTitle from '@/components/cards/defaults/CardWithTitle'
import { Button } from '@chakra-ui/react'

export const LicenseUserTable = ({ userLicenses, setScreenLoader }) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const userLicensesIds = userLicenses.map(userLicense => userLicense.id)
  const rows = userLicenses.map(userLicense => {
    const { license } = userLicense
    return (
      <tr key={userLicense.id}>
        <td>
          { license.name }
        </td>
        <td>
          { format(parseISO(userLicense.activationDate), 'yyyy-MM-dd H:mm') }
        </td>
        <td>
        { license.price }
        </td>
      </tr>
    )
  })
  const onDeactivateUserLicenses = async () => {
    setScreenLoader(true)

    await serviceDeactivateUserLicenses(userLicensesIds, getAccessToken)

    window.location.reload()
  }

  return (
    <CardWithTitle
      title="Acquired licenses"
    >
      <DefaultTable
        className="mb-sm"
        style={{ width: '100%' }}
      >
        <DefaultTable.Header>
          <tr>
            <th>License</th>
            <th>Activation Date</th>
            <th>Price</th>
          </tr>
        </DefaultTable.Header>
        <DefaultTable.Body>
          { rows }
        </DefaultTable.Body>
      </DefaultTable>
      <div>
        <Button
          onClick={onDeactivateUserLicenses}
          colorScheme="red"
        >
          Deactivate User Licenses
        </Button>
      </div>
    </CardWithTitle>
  )
}
